/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioSharingDto
 */
export interface PortfolioSharingDto {
    /**
     * Total number of portfolios with shareType != Disabled
     * @type {number}
     * @memberof PortfolioSharingDto
     */
    sharedPortfolios: number;
    /**
     * Number of portfolios with shareType = Public
     * @type {number}
     * @memberof PortfolioSharingDto
     */
    publicPortfolios: number;
    /**
     * Number of portfolios with shareType = Members
     * @type {number}
     * @memberof PortfolioSharingDto
     */
    membersOnlyPortfolios: number;
    /**
     * Percentage of portfolios that are shared (not Disabled)
     * @type {number}
     * @memberof PortfolioSharingDto
     */
    sharingRate: number;
}

export function PortfolioSharingDtoFromJSON(json: any): PortfolioSharingDto {
    return PortfolioSharingDtoFromJSONTyped(json, false);
}

export function PortfolioSharingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioSharingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sharedPortfolios': json['sharedPortfolios'],
        'publicPortfolios': json['publicPortfolios'],
        'membersOnlyPortfolios': json['membersOnlyPortfolios'],
        'sharingRate': json['sharingRate'],
    };
}

export function PortfolioSharingDtoToJSON(value?: PortfolioSharingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sharedPortfolios': value.sharedPortfolios,
        'publicPortfolios': value.publicPortfolios,
        'membersOnlyPortfolios': value.membersOnlyPortfolios,
        'sharingRate': value.sharingRate,
    };
}

